// @core/api/endpoints/subscription/delete_product_bundle.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Archive product bundle
 * Archives a product bundle. Existing subscriptions continue but no new subscriptions are allowed.
 */
export async function DeleteProductBundle(
  bundle_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bundles/:bundle_id`;
  requestPath = requestPath.replace(':bundle_id', encodeURIComponent(bundle_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
